const isPlainPrimaryClick = (event) =>
  event.button === 0 &&
  !event.metaKey &&
  !event.ctrlKey &&
  !event.shiftKey &&
  !event.altKey;

const isCartPageLink = (anchor) => {
  try {
    const url = new URL(anchor.href, window.location.href);
    if (url.origin !== window.location.origin) return false;

    const normalizePath = (path) => {
      if (!path || path === "/") return "/";
      return path.replace(/\/+$/, "");
    };

    const root = window.Shopify?.routes?.root || "/";
    const cartPath = normalizePath(root + "cart");

    return normalizePath(url.pathname) === cartPath;
  } catch {
    return false;
  }
};

document.addEventListener(
  "click",
  (event) => {
    if (event.defaultPrevented || !isPlainPrimaryClick(event)) return;

    const anchor = event.target.closest("a[href]");
    if (!anchor || anchor.getAttribute("aria-controls") === "cart-drawer") return;
    if (!isCartPageLink(anchor)) return;

    const drawer = document.getElementById("cart-drawer");
    const nativeCartControl = document.querySelector('[aria-controls="cart-drawer"]');

    if (!drawer || !nativeCartControl) return;

    event.preventDefault();
    nativeCartControl.click();
  },
  true
);